import React, { PropTypes, Component } from 'react';
import webglEnabled from 'webgl-enabled';
import THREE from 'three';
import STLLoader from './STLLoader'
import TrackballControlls from './TrackballControlls'

var camera, scene, renderer, controls;
var cameraTarget, pivot;

class Viewer extends Component {
  static propTypes = {
    stlUrl: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);

    this._init = this._init.bind(this);
    this._render = this._render.bind(this);
    this._animate = this._animate.bind(this);
    this._onWindowResize = this._onWindowResize.bind(this);
  }

  componentDidMount() {
    if(webglEnabled()) {
      this._init();
      this._animate();
    }
    else {
      var node = document.createElement('p');
      node.className = 'alert alert-warning';
      node.innerHTML += 'Your graphics card does not seem to support <a href="http://khronos.org/webgl/wiki/Getting_a_WebGL_Implementation">WebGL</a> you will not be able to see the preview.<br />';
      node.innerHTML += 'Find out how to get it <a href="http://get.webgl.org/">here</a>.';

      document.getElementsByClassName('Viewer')[0].appendChild(node);
    }
  }

  _init() {
    var self = this;
    var stl = this.props.stlUrl;

    var width = document.getElementsByClassName('Viewer')[0].offsetWidth;
    var height = width / 2;

    scene = new THREE.Scene();
    camera = new THREE.PerspectiveCamera(90, width / height, 0.1, 1000 );
    cameraTarget = new THREE.Vector3( 0, 0, 0 );

    renderer = new THREE.WebGLRenderer({alpha: true});
    renderer.setSize(width, height);
    document.getElementsByClassName('Viewer')[0].appendChild(renderer.domElement);

    // Add a light source
    var pointLight = new THREE.PointLight(0xFFFFFF)
    pointLight.position.x = 0
    pointLight.position.y = 0
    pointLight.position.z = 500
    scene.add(pointLight)

    pivot = new THREE.Group();
    scene.add( pivot );

    controls = new TrackballControlls(camera, document.getElementsByClassName('Viewer')[0]);
    controls.rotateSpeed = 1.0;
    controls.zoomSpeed = 1.2;
    controls.panSpeed = 1.2;

    controls.noZoom = false;
    controls.noPan = false;

    controls.staticMoving = true;
    controls.dynamicDampingFactor = 0.3;

    controls.keys = [ 65, 83, 68 ];

    controls.addEventListener('change', self._render);

    var loader = new STLLoader();
    loader.load(stl, function ( geometry ) {
      var material = new THREE.MeshPhongMaterial({
        color: 0x337ab7,
        specular: 0x111111,
        shininess: 20
      });
      var mesh = new THREE.Mesh( geometry, material );

      // Use a box to center the mesh on the screen
      var box = new THREE.Box3().setFromObject(mesh);
      box.center(mesh.position);
      mesh.position.multiplyScalar(-1);

      // Set the camera so far away that the mesh fills the view in its height
      var y = geometry.boundingBox.max.y / 2;
      var x = geometry.boundingBox.max.x / 2;
      var offset = y;
      if(x > y) {
        offset = x;
        var ratio = x / y;
        if(ratio > 2) {
          offset = x / 2;
        }
      }
      offset += geometry.boundingBox.max.z + 2;

      camera.position.set(0, 0, offset);

      pivot.add( mesh );
      camera.lookAt(cameraTarget);

      self._render();
    });

    //var axisHelper = new THREE.AxisHelper(500);
    //scene.add( axisHelper );

    window.addEventListener( 'resize', this._onWindowResize, false );
  }

  _onWindowResize() {
    var width = document.getElementsByClassName('Viewer')[0].offsetWidth;
    var height = width / 2;

    camera.aspect = width / height;
    camera.updateProjectionMatrix();

    renderer.setSize(width, height);

    controls.handleResize();

    this._render();
  }

  _animate() {
    requestAnimationFrame(this._animate);
    controls.update();
  }

  _render() {
    renderer.render(scene, camera);
  }

  render() {
    return (
      <div className="Viewer"></div>
    );
  }
}

export default Viewer;



/** WEBPACK FOOTER **
 ** ./src/components/Viewer/Viewer.js
 **/